/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalReauthReportGenerationTrigger = {
    Manual: 'manual',
    Scheduled: 'scheduled',
} as const;
export type PalReauthReportGenerationTrigger = typeof PalReauthReportGenerationTrigger[keyof typeof PalReauthReportGenerationTrigger];


export function instanceOfPalReauthReportGenerationTrigger(value: any): boolean {
    for (const key in PalReauthReportGenerationTrigger) {
        if (Object.prototype.hasOwnProperty.call(PalReauthReportGenerationTrigger, key)) {
            if (PalReauthReportGenerationTrigger[key as keyof typeof PalReauthReportGenerationTrigger] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PalReauthReportGenerationTriggerFromJSON(json: any): PalReauthReportGenerationTrigger {
    return PalReauthReportGenerationTriggerFromJSONTyped(json, false);
}

export function PalReauthReportGenerationTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthReportGenerationTrigger {
    return json as PalReauthReportGenerationTrigger;
}

export function PalReauthReportGenerationTriggerToJSON(value?: PalReauthReportGenerationTrigger | null): any {
    return value as any;
}

export function PalReauthReportGenerationTriggerToJSONTyped(value: any, ignoreDiscriminator: boolean): PalReauthReportGenerationTrigger {
    return value as PalReauthReportGenerationTrigger;
}

